export enum SSOType {
  oneLogin = "one-login",
  axxess = "axxess",
  azureAD = "azure-ad",
  okta = "okta",
  googleWorkspace = "google-workspace"
}
